var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oci-ethos-button-container"},[_c('b-button',{attrs:{"type":"submit"},on:{"click":_vm.HideEthos}},[_vm._v(" OK ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }